import {getConfig, getIcon} from '@cohort/wallet/components/toasts/Toast';
import useThemeContext from '@cohort/wallet/hooks/useThemeContext';
import {useCallback} from 'react';
import type {Id, ToastOptions, TypeOptions} from 'react-toastify';
import {toast} from 'react-toastify';

export default function useNotify(): (
  type: TypeOptions,
  message: unknown,
  options?: ToastOptions
) => Id {
  const {hasDarkBg} = useThemeContext();

  return useCallback(
    (type: TypeOptions, message: unknown, options?: ToastOptions) => {
      const errorMessage = message instanceof Error ? message.message : message;

      return toast(errorMessage as React.ReactNode, {
        toastId: 'toast',
        ...options,
        type,
        icon: getIcon(type),
        ...getConfig(hasDarkBg),
      });
    },
    [hasDarkBg]
  );
}
